export default {
  AUTHORIZATION: "AUTHORIZATION",
  PERSONCENTER: "PERSONCENTER",
  // CURRENTUSERINFO: "CURRENTUSERINFO"
};
